export function printAddress(object: any) {
    const streetPart = [object.streetName, object.streetNumber].filter(Boolean).join(" ");
    const cityPart = [object.zipCode, object.city].filter(Boolean).join(" ");

    return [streetPart, cityPart].filter(Boolean).join(", ");
}

export function printContactAddress(object: any) {
    const streetPart = object.address;
    const cityPart = [object.zipCode, object.cityName].filter(Boolean).join(" ");

    return [streetPart, cityPart].filter(Boolean).join(", ");
}
